import { render } from "./TradingPage.vue?vue&type=template&id=3036ef8f&scoped=true"
import script from "./TradingPage.vue?vue&type=script&lang=js"
export * from "./TradingPage.vue?vue&type=script&lang=js"

import "./TradingPage.vue?vue&type=style&index=0&id=3036ef8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3036ef8f"]])

export default __exports__